import { HttpErrorResponse } from '@angular/common/http';

export function isRefreshTokenInvalidError(error: unknown): boolean {
    return error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403);
}